module.exports = __webpack_public_path__ + "img/1.1be09d7a.png";